import script from "./AlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertModal.vue?vue&type=script&setup=true&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=350a085c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350a085c"]])

export default __exports__